import { isStringArray } from "infrastructure/helpers";
import { IAppRouteProps } from "ui/app/navigation";
import { IAuthorizationData } from "ui/app/user-provider";

export const getAuthorizationData = (appRoutes: IAppRouteProps[], path: string): IAuthorizationData[] | undefined => {
  for (const route of appRoutes) {
    if (isStringArray(route.path)) {
      for (const subPath of route.path) {
        if (subPath === path) {
          return route.requiredAuthorizationData;
        }
      }
    } else {
      if (route.path === path) {
        return route.requiredAuthorizationData;
      }
    }
  }
};
